import { render, staticRenderFns } from "./TheSuggestion.vue?vue&type=template&id=779de514&scoped=true&"
import script from "./TheSuggestion.vue?vue&type=script&lang=js&"
export * from "./TheSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./TheSuggestion.vue?vue&type=style&index=0&id=779de514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779de514",
  null
  
)

export default component.exports